import React, { useState, useEffect } from "react";
import { usePost } from "seed/api";
import SelectField from "components/util/schema_form/fields/SelectField"
import l from "components/util/l";

const DynamicSelectField = (props) => {

  const userId = sessionStorage.getItem("id");
  const name = props.name;
  const flowId = props.flowId;
  const dynamicDependencies = props.dynamicDependencies ?? [];
  const dynamicOptions = props.dynamicOptions;
  const source = dynamicOptions.source ?? "";
  const sourceValue = dynamicOptions.value ?? "";
  const values = props.values;
  const setFieldValue = props.setFieldValue;
  const getOptions = dynamicOptions.get_options ?? (() => []);
  const callParams = dynamicOptions.call_params ?? {};
  const actionId = props.actionId;
  const sectionIdx = props.sectionIdx;
  const hasAllDependencies = dynamicDependencies.filter(depName => depName in values).length == dynamicDependencies.length;
  const [options, setOptions] = useState(null)
  const [depsValues, setDepsValues] = useState(null)
  const [callCall, reqCall] = usePost(`/call/${actionId}/${sourceValue}`, {
    onCompleted: (data) => setOptions(data)
  })

  const initOptions = () => {
    setFieldValue(name, "")
    setOptions(null)
    if (source == "CALL")
      callCall({
        user_id: parseInt(userId),
        flow_id: parseInt(flowId),
        section_idx: sectionIdx,
        values: props.values,
        call_params: callParams
      })
    else if (source == "callback")
      setOptions(getOptions(sectionIdx, values))
  }

  useEffect(() => {
    if (hasAllDependencies) {
      const newDepsValues = dynamicDependencies.map(depName => values[depName])
      //If there are no change in deps, break
      if (JSON.stringify(depsValues) == JSON.stringify(newDepsValues)) return 
      setDepsValues(newDepsValues)
      initOptions()
    }
  }, [values]); // eslint-disable-line react-hooks/exhaustive-deps

  const onChangeSelect = (value, label) => {
    if (props.onChange)
      props.onChange(value, label)
  }

  const loading = options == null || reqCall.loading;
  const error = reqCall.error;
  const placeholder = !hasAllDependencies ? ""
    : error ? l("Ha ocurrido un error%SC048")
      : loading ? l("Cargando...%SC049") : l("Selecciona una opción%GA025")

  return (
    <SelectField
      {...props}
      placeholder={placeholder}
      options={Array.isArray(options) && !reqCall.loading ? options : []}
      onChange={onChangeSelect}
    />
  )

}

export default DynamicSelectField;